// extracted by mini-css-extract-plugin
module.exports = {"MoreBtn":"MoreBtn_MoreBtn__2lnPQ"};